<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M10 15.3995L13.8799 17.8549C14.5904 18.3049 15.4599 17.6397 15.2729 16.7984L14.2445 12.1811L17.6756 9.07027C18.302 8.50289 17.9654 7.42682 17.1427 7.35834L12.6271 6.95726L10.8601 2.59428C10.5422 1.80191 9.45775 1.80191 9.13988 2.59428L7.3729 6.94748L2.85727 7.34856C2.03455 7.41703 1.69798 8.4931 2.32437 9.06049L5.7555 12.1713L4.7271 16.7886C4.54012 17.6299 5.40958 18.2951 6.12012 17.8451L10 15.3995Z"
  />
</svg>
